<div class="packagesMobile">
  <ng-container *ngIf="isPlan; else packagesSection">
    <div class="plans">
      <div class="card" *ngFor="let package of packagesFiltered" [ngClass]="{recommended : package.preferred}">
        <div class="header" *ngIf="package.preferred">
          Melhor escolha
        </div>
        <div class="body">
          <div class="radioButton">
            <mat-radio-button [ngClass]="{recommended : package.preferred}" (click)="selectOption(package)"
              [checked]="selectedOption?.product._id === package.product._id"></mat-radio-button>
          </div>
          <div class="content">
            <div class="title">
              <ng-container *ngIf="productService.isVariableProduct(package.product); else fixedPrice">
                <p class="variablePrice">
                  a partir de R$
                  <input type="number" class="input-custom-plan" [value]="customValue"
                    (input)="updateCustomValue(package, $event.target.value)"
                    (focusout)="checkCustomValue(package, $event)" />
                  /mês*
                </p>
                <p class="error-message-customValue" *ngIf="showCustomValueError">Você não pode adiquirir esse produto
                  por
                  menos de R$ {{package.baseValue}} </p>
              </ng-container>
              <ng-template #fixedPrice>
                <ng-container *ngIf="campaign; else: noCampaign">
                  <div class="price-row">
                    <div class="from" *ngIf="package.appliedDiscounts?.length > 0">
                      <p class="from">De R$ {{package.baseValue}}</p>
                    </div>
                    <p class="current-price">
                      Por R$ <b>{{package.totalValue}}</b> /mês*
                    </p>
                  </div>
                </ng-container>
                <ng-template #noCampaign>
                  <div class="price-row">
                    <p class="current-price">
                      R$ <b>{{package.baseValue}}</b> /mês*
                    </p>
                  </div>
                </ng-template>
              </ng-template>
            </div>
            <div class="economyRater" [ngClass]="{higlighter : package.preferred}">
              <img src="assets/images/icons/gift_alt_green.svg" *ngIf="package.preferred">
              {{package.featuredText}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #packagesSection>
    <div class="packages">
      <div class="title">
        <p>Compre créditos quando precisar</p>
        <p><b>Escolha o valor de recarga:</b></p>
      </div>
      <div class="custom-select" [class.open]="isOpen">
        <div class="select-trigger" id="select-consulta-product" (click)="toggleSelect()"
          style="display: flex; align-items: center; justify-content: space-between;">

          <span *ngIf="selectedOption && productService.isVariableProduct(selectedOption.product)"
            (click)="$event.stopPropagation()">
            <span>Outro valor R$</span>
            <input type="number" class="input-custom-plan" [(ngModel)]="customValue" [value]="customValue"
              (input)="updateCustomValue(selectedOption, $event.target.value)"
              (focusout)="checkCustomValue(selectedOption, $event)"
              style="width: 80px; font-weight: bold; border: none; background: transparent; outline: none;">
          </span>




          <div class="price-container">
            <div class="from"
              *ngIf="selectedOption?.appliedDiscounts?.length > 0 && selectedOption.discountedValue !== 0">
              De R$ {{selectedOption.baseValue.toFixed(2).replace('.', ',')}}
            </div>
            <div class="value-wrapper">
              <span *ngIf="selectedOption && !productService.isVariableProduct(selectedOption.product)">
                R$ <b>{{selectedOption?.totalValue.toFixed(2).replace('.', ',').replace(",00","")}}</b>
              </span>
            </div>
          </div>

          <span *ngIf="!selectedOption">Selecione uma opção</span>

          <img src="/assets/images/icons-stepper/chevron_left.svg" style="pointer-events: none;">
        </div>

        <ul class="options-list">
          <ng-container *ngIf="!campaign; else optionListCampaign">
            <li *ngFor="let option of packagesFiltered" (click)="selectOption(option)">
              <ng-container *ngIf="productService.isVariableProduct(option.product)">
                Outro valor
              </ng-container>
              <ng-container *ngIf="!productService.isVariableProduct(option.product)">
                R$ {{option?.baseValue.toFixed(2).replace('.', ',').replace(",00","")}}
              </ng-container>
            </li>
          </ng-container>
          <ng-template #optionListCampaign>
            <li *ngFor="let option of packagesFiltered"
              [ngClass]="{selected: selectedOption?.product._id === option.product._id, discounted: option?.appliedDiscounts?.length > 0 && option.discountedValue !== 0}"
              (click)="selectOption(option)">
              <ng-container *ngIf="productService.isVariableProduct(option.product); else standardPackage">
                <div class="optionBody">
                  <div class="simpleValue">Escolher outro valor</div>
                </div>
              </ng-container>
              <ng-template #standardPackage>
                <div class="optionBody"
                  *ngIf="option?.appliedDiscounts?.length > 0 && option.discountedValue !== 0; else noDiscount">
                  <div class="line">
                    <div class="profitable" *ngIf="option.profitable">
                      Mais vantajoso
                    </div>
                  </div>
                  <div class="line">
                    <div class="from">
                      de R$ {{option?.baseValue.toFixed(2).replace('.', ',')}}
                    </div>
                    <div class="to">
                      Por R$ {{option?.totalValue.toFixed(2).replace('.', ',')}}
                    </div>
                  </div>
                  <div class="line">
                    <div class="economyValue">
                      Economia de R$ {{(option.baseValue - option.totalValue).toFixed(2).replace('.',
                      ',')}}
                    </div>
                    <div class="discountPercentage">
                      {{(((option.baseValue - option.totalValue) / option.baseValue) * 100).toFixed(2)}}% OFF
                    </div>
                  </div>
                </div>
                <ng-template #noDiscount>
                  <div class="simpleValue">R$ {{option?.baseValue.toFixed(2).replace('.', ',')}}</div>
                </ng-template>
              </ng-template>
              <mat-icon *ngIf="selectedOption?.product._id === option.product._id" class="checkIcon">check</mat-icon>
            </li>
          </ng-template>
        </ul>
      </div>

      <div class="overlay" *ngIf="isOpen" (click)="isOpen = false"></div>
      <p class="error-message-customValue" *ngIf="showCustomValueError">Você não pode adiquirir esse produto por
        menos de R$ {{selectedOption.baseValue}} </p>
    </div>

  </ng-template>

  <div class="description">
    <div>
      <p>O que você pode fazer:</p>
    </div>
    <div class="features">
      <div class="feature-list" *ngIf=" selectedOption?.featureList.length > 0">
        <ng-container *ngFor="let feature of selectedOption.featureList; let last = last">
          <div class="feature">
            <div class="contentLeft">
              <p class="quantity">
                {{feature.requests}}
              </p>
            </div>
            <div class="contentRight">
              <p class="featureName">
                {{feature.name}}
              </p>
              <p class="featureValue" *ngIf="feature.fromValue || feature.toValue">
                <ng-container *ngIf="isPlan; else notPlan">
                  ( <span class="fromValue">
                    <span>{{feature.fromValue }}</span>
                  </span>
                  <span class="toValue">
                    <b>{{feature.toValue }}</b>
                  </span> )
                </ng-container>
                <ng-template #notPlan>
                  <span class="toValue">
                    (<b>{{feature.toValue || feature.fromValue }}</b>)
                  </span>
                </ng-template>
              </p>
            </div>
          </div>
          <div class="line" *ngIf="!last">
            <p>ou</p>
            <hr>
          </div>
        </ng-container>
      </div>


      <ng-container *ngIf="selectedOption?.additionalProducts?.length > 0">
        <hr>
        <div class="additional-features" *ngFor="let additional of selectedOption.additionalProducts">
          <div class="contentRight">
            <h1>{{additional.title}}</h1>
            <p [innerHTML]="additional.subtitle"></p>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="subscribe-button" *ngIf="!this.hiddenButton" [ngClass]="{'disable': this.isActivePlan}">

      <button (click)="onBuyClick()" [disabled]="this.isActivePlan">
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</div>